import getPhoneticSystem from '../systems/getPhoneticSystem';

/** Compatibility shape for the existing canvas renderer and helper consumers. */
export interface DecomposedSyllable {
    onset: string;
    rhyme: string;
    tone: string | number;
    syll: string;
    notone: string;
    type: string;
    ambiguous?: boolean;
}

const decomposeSyllable = (text: string, system: string): DecomposedSyllable => {
    const syllable = getPhoneticSystem(system).decomposeSyllable(text);
    const result: DecomposedSyllable = {
        onset: syllable.onset,
        rhyme: syllable.rhyme,
        tone: syllable.valid ? String(syllable.tone) : 0,
        syll: syllable.syllable,
        notone: syllable.notone,
        type: syllable.type,
    };
    if (!syllable.valid) result.ambiguous = syllable.ambiguous;
    return result;
};

export default decomposeSyllable;
